import { GET_PROJECT_BY_ID_URL } from "../config/constants";
import { getAuthHeader } from "../config/auth";
import { apiFetch } from "../utils/apiClient";

export class ProjectNotFoundError extends Error {
  constructor(projectId) {
    super(`Project not found for ID ${projectId}`);
    this.name = "ProjectNotFoundError";
  }
}

/** Raw shape of a single project as returned by GET /projects/{projectId}. */



/** Fetches a single project by id from GET /projects/{projectId}. */
export async function getProjectById(projectId){
    console.log("Fetching project details for projectId:", projectId);
  const authHeader = getAuthHeader();
  if (!authHeader) {
    throw new Error("Authentication token not found. Please log in again.");
  }

  const response = await apiFetch(GET_PROJECT_BY_ID_URL(projectId), {
    method: "GET",
    headers: {
      Authorization: authHeader,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  }, "Failed to fetch project details. Please try again.", { passthrough: [404] });

  if (response.status === 404) {
    throw new ProjectNotFoundError(projectId);
  }

  if (!response.ok) {
    throw new Error(`Failed to fetch project details (${response.status})`);
  }

  const payload = (await response.json());

  console.log("Raw project details payload:", payload);

  // Some backends wrap the project under a `project`/`data` envelope; unwrap defensively.
  const unwrapped =
    (payload ).project ??
    (payload).data ??
    (payload);

  if (!unwrapped || typeof unwrapped !== "object") {
    throw new ProjectNotFoundError(projectId);
  }

  return unwrapped;
}
